import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../../components';
import { Box, Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../../utils';
import { RESULT_TYPE } from '../../../../../../constants/dropdown';
import { EmrTestItemDetail } from './EmrTestItemDetail';
import { CustomButtonn } from '../../../../../../components';
import { useLocation } from 'react-router-dom';


const TABLE_COLUMNS = [
  {
    header: 'Emr Item  Name',
    accessor: 'emr_item_name'
  },
  {
    header: 'Result Type',
    accessor: 'result_type'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];
const TEST_ITEM_HEADER = [
  {
    header: 'Emr Item Help',
    accessor: 'emr_item_help'
  },
  {
    header: 'Left Value',
    accessor: 'left_value'
  },
  {
    header: 'Right  Value',
    accessor: 'right_value'
  },

  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialEmrTestItemDataObj = {
  data: [],
  loading: false
};

export const EmrTestItemMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [testItemDataObj, setTestItemDataObj] = useState(initialEmrTestItemDataObj);
  const [loading, setLoading] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();


  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({ emr_item_name: Yup.string().required(' Emr Item Name is required') })),
    defaultValues: { emr_item_name: '' },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('emr_item_name', selectedRecord.emr_item_name);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/emr-main-group-update' : '/emr-main-group-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        emr_group_name: formValues.emr_group_name,
        emr_result_type: formValues.emr_result_type,
        status: 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Emr Main Group`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Emr Main Group`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/emr-main-group-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Emr Main Group', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Emr Main Group', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setTestItemDataObj({ loading: true });
    const response = await request('/emr-test-item-list', { method: 'GET' });
    if (response.success) {
      setTestItemDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setTestItemDataObj({ loading: false });
    }
  };

  const handleAddDetail = (e, detail) => {
    e.preventDefault();
    setDetailList((prevList) => [...prevList, detail]);
    setDetailsDialogOpen(false);
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',

          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3">
                Emr Test Item
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained">Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography sx={{ flex: 0.1, fontSize: '1.4rem' }}>Emr Item Name</Typography>
                <TextField
                  name="emr_item_name"
                  sx={{ flex: 0.8 }}
                  placeholder="Enter Item Name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography sx={{ flex: 0.1, fontSize: '1.4rem' }}>Result Type</Typography>
                <SelectTag
                  name="result_type"
                  formControlSX={{ flex: 0.8 }}
                  disabled={!['new', 'edit'].includes(currentAction)}
                  menus={RESULT_TYPE}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem' }}>Result In EMR</Typography>
                <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="result_in_emr" />
              </Stack>
            </Stack>
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  sx={{ minWidth: 'auto', p: 0.5 }}
                  variant="contained"
                  onClick={() => setDetailsDialogOpen(true)}
                >
                  <Typography>Add Details</Typography>
                </Button>
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <Table
                  containerSX={{ flex: 1 }}
                  data={detailList}
                  columns={TEST_ITEM_HEADER}
                  size="small"
                  showDeleteAction={true}
                />
              </Box>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            EMR Test Item Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 3 }}
          columns={TABLE_COLUMNS}
          data={testItemDataObj.data || []}
          loading={testItemDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={detailsDialogOpen}
        PaperProps={{ sx: { width: '60%', height: '50vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <EmrTestItemDetail onClose={() => setDetailsDialogOpen(false)} onAdd={handleAddDetail} />
      </Dialog>
    </>
  );
};
